
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightSearchlightColourOff as ObiLightSearchlightColourOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-searchlight-colour-off.js';
 
 
 

 
 export const ObiLightSearchlightColourOff = createComponent({
   react: React,
   tagName: 'obi-light-searchlight-colour-off',
   elementClass: ObiLightSearchlightColourOffElement,
   events: {
     
   }
  });
 
 